export enum Locale {
	cs = "cs",
	en = "en",
}

export type Localized<Type> = Record<Locale, Type>;

export type LocalizedString = Localized<string>;

export type LocalizedStringArray = Record<Locale, string[]>;

export type LocalizedBoolean = Record<Locale, boolean>;

export type LocalizedID = Record<Locale, string>;

export type RelatedLocaleID = Partial<LocalizedID>;
